import styled from "@emotion/styled"
import Image from "components/Image"

const ArticleAsideBlogPostImage = styled(Image)`
  background: #efeff6;
  border-radius: 15px;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  & svg {
    width: 100%;
    height: 100%;
  }

  ${({ theme }) => theme.breakpoints.down("lg")} {
    width: 100%;
    height: 200px;
    padding: 20px;
    margin-bottom: 13px;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    width: 243px;
    height: 160px;
    padding: 13px;
    margin-bottom: 13px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    width: 303px;
    height: 200px;
    padding: 16px;
    margin-bottom: 16px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    width: 379px;
    height: 250px;
    padding: 20px;
    margin-bottom: 20px;
  }
`

export default ArticleAsideBlogPostImage
